import type { SVGProps } from 'react'

export const UpThree = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1080 333' {...props}>
    <path d='M1087.69 58.1344C1082.26 54.9778 1218.22 -5.99433 1101.58 14.6993C1008.27 31.2541 961.119 78.5655 894.21 78.5655C806.339 78.5655 733.332 0 632 0C561.475 0 469.972 55.7975 395.106 63.289C338.143 68.989 208.26 0 125.663 0C-12.6756 0 -67.3685 154.233 -116.655 159.905C-182.479 167.481 -144.082 257.003 -116.655 346.091C251.133 344.823 1167.01 343.054 1188.58 345.965C1188.73 346.122 1188.86 346.165 1188.95 346.091C1189.01 346.048 1188.88 346.006 1188.58 345.965C1182.32 339.602 1128.43 146.338 1087.69 58.1344Z' />
  </svg>
)

UpThree.toString = () => 'up3'
